import { apiClient } from './client';

export interface FeatureFlagsResponse {
  enabled_features: string[];
}

export const featureFlagsEndpoints = {
  getEnabledFeatures: async (): Promise<FeatureFlagsResponse> => {
    return await apiClient.get<FeatureFlagsResponse>('/feature_flags');
  },
};
